import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HiringList from './hiring_list';
import HiringDetail from './hiring_detail';

class Hiring extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <HiringList/>;
    }else{
      if(params.id===undefined){
        view = <HiringDetail/>;
      }else{
        view = <HiringDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Hiring.contextTypes = {
  router: PropTypes.object
};

export default Hiring;
